module.exports = __webpack_public_path__ + "static/media/sap.1c102e2c.png";